<template>
    <!-- レポート出力先 -->
    <fieldset id="reportDir">
        <legend>レポート出力先フォルダ(任意)</legend>
        <div>
            レポートを出力するフォルダのパスを入力してください。<br>
            エクスプローラーからパスをコピーし、入力フォームにそのままペーストしてください。
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. 何も入力しなかった場合、コマンドライン実行用プロジェクトフォルダ配下のreportsフォルダに出力されます。<br>
            <span style="margin-left: 18px;"></span>※コマンドライン実行用プロジェクトキー<br>
            <span style="margin-left: 18px;"></span>・Webアプリ用 :「commandlinetestrun」<br>
            <span style="margin-left: 18px;"></span>・Windowsアプリ用 :「commandlinetestpjwin」<br>
            <span style="margin-left: 18px;"></span>・モバイルアプリ用 :「commandlinetestpjmob」
        </div>
        <div class="form-area">
            <label for="reportDir">・レポートを出力するフォルダのパス</label>
            <PathHelp /><br>
            <input id="reportDir" type=" text" class="input-text" v-model="inputedReportDir" name="reportDir"
                @input="updateOpt" placeholder="/Path/to/your_reports">
        </div>
    </fieldset>
</template>

<script>
import { onMounted, ref } from 'vue';

import strUtils from '@/js/strUtils';
import cacheUtils from '@/js/cacheUtils';


export default {
    name: 'ReportDirForm',
    setup(_, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedReportDir = ref("")

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            let createdOpt = ""

            // レポート出力先
            if (inputedReportDir.value) {
                inputedReportDir.value = await strUtils.replaceSlush(inputedReportDir.value)
                createdOpt += ` --output_report_dir_path ${inputedReportDir.value}`
            }

            // cacheに保存
            await cacheUtils.saveData("reportsDir", inputedReportDir.value)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "reportsDir", createdOpt)
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedReportDir.value = await cacheUtils.getData("reportsDir")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedReportDir,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
